let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3btXp")).then(() => parcelRequire('4Z6cs'));